/*
 * Grippatch - sepette tamamlayici urun onerisi
 *
 * ONCELIK SIRASI (2026-08-24'te genisletildi):
 *   1. BIRLIKTE ALINANLAR   -> Shopify Recommendations `intent=complementary`
 *   2. ILGILI URUNLER       -> Shopify Recommendations `intent=related`
 *   3. Kullanicinin daha once TIKLADIGI urunler -> tarayici hafizasi
 *   4. AYNI KATEGORIDEN     -> koleksiyon listesi
 *
 * SIRA NEDEN DEGISTI: kutu 4 urunluk dar bir listeydi, simdi sepet
 * sayfasinda 13 urunluk serit. "Bunlari da sepete eklediler" basligi
 * ancak GERCEKTEN birlikte alinma verisiyle dogru olur; gezme gecmisi
 * o iddiayi tasimaz, o yuzden 3. siraya indi.
 *
 * `complementary` Shopify'in "sikca birlikte alinan" iliskisidir; magaza
 * panelinde (Search & Discovery) tanimlanmamissa BOS doner - bu yuzden
 * hemen ardindan `related` geliyor, o otomatik hesaplaniyor.
 *
 * SEPETTEKI HER URUN denenir (onceki hal yalniz son eklenene bakiyordu).
 *
 * Basamaklar sirayla denenir ve kutu dolana kadar bir SONRAKINE gecilir.
 * Yani 1. basamak tek urun verdiyse kalan uc yer 2. basamaktan tamamlanir -
 * yarim dolu bir serit gostermek yerine sirayi koruyup ustunu dolduruyoruz.
 *
 * 1. BASAMAK NEDEN TARAYICIDA: hangi urune tiklandigi sunucuda tutulmuyor
 * (ne cerez ne hesap gerekiyor). `localStorage`e yalnizca urun handle'i
 * yaziliyor - kisisel veri degil, baska kimseye gitmiyor, cihazda kaliyor.
 *
 * 2. BASAMAK NEDEN SHOPIFY UCU: "birlikte satin alinmis" bilgisi siparis
 * gecmisi ister; Theme Access anahtari Admin API'ye giremez. Shopify'in
 * `/recommendations/products.json` ucu bu hesabi kendisi yapip donuyor,
 * yetki gerektirmiyor. Yeni magazada veri birikene kadar bos donebilir -
 * o yuzden 3. basamak var.
 */

(function () {
  'use strict';

  var ANAHTAR = 'grp_gezilen';
  var GECMIS_SINIR = 20;

  /* Magazanin para bicimiyle ayni: "9.200,00 TL" (2026-08-21'de Turkce'ye
     cevrildi). Sunucunun bastigi fiyatlarla ayrismasin. */
  var para = new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  /* ------------------------------------------------- gezilen urun kaydi */

  function gecmisOku() {
    try {
      var ham = localStorage.getItem(ANAHTAR);
      var l = ham ? JSON.parse(ham) : [];
      return Array.isArray(l) ? l : [];
    } catch (e) {
      return []; // gizli sekme / depolama kapali - sessizce bos gecmis
    }
  }

  function gecmiseYaz(handle) {
    if (!handle) return;
    try {
      var l = gecmisOku().filter(function (x) { return x !== handle; });
      l.unshift(handle);
      localStorage.setItem(ANAHTAR, JSON.stringify(l.slice(0, GECMIS_SINIR)));
    } catch (e) { /* depolama yoksa oneri 2. basamaktan calisir */ }
  }

  function izle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (m) gecmiseYaz(decodeURIComponent(m[1]));
  }

  /* ------------------------------------------------------- veri cekme */

  function json(url) {
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* Uc ayri uc uc ayri bicimde donuyor; tek bicime indiriyoruz.
     - /products/<h>.js        : price KURUS (tam sayi), featured_image string
     - /recommendations/...    : variants[0].price kurus, images[0] string
     - /collections/<h>/...    : variants[0].price "953.00" METIN, images[0].src */
  function normalle(u) {
    if (!u) return null;
    var v = (u.variants && u.variants[0]) || {};
    var fiyat = null;

    if (typeof u.price === 'number') fiyat = u.price / 100;
    else if (typeof v.price === 'number') fiyat = v.price / 100;
    else if (typeof v.price === 'string') fiyat = parseFloat(v.price);

    var gorsel = '';
    if (typeof u.featured_image === 'string') gorsel = u.featured_image;
    else if (u.featured_image && u.featured_image.url) gorsel = u.featured_image.url;
    else if (u.images && u.images.length) {
      gorsel = typeof u.images[0] === 'string' ? u.images[0] : (u.images[0].src || '');
    }

    var satilabilir = u.available !== undefined ? u.available : (v.available !== false);

    /* GORSELI OLMAYAN URUN ONERILMEZ (Faruk, 2026-08-24): kart bos bir kutu
       olarak duruyor ve seridin akisini bozuyor. Tukenen urun de ayni sekilde
       eleniyor - satin alinamayan bir seyi onermek anlamsiz. */
    if (!u.handle || fiyat === null || !v.id || !satilabilir || !gorsel) return null;
    return { handle: u.handle, baslik: u.title, fiyat: fiyat, gorsel: gorsel, varyant: v.id };
  }

  /* -------------------------------------------------------- basamaklar */

  function gecmisBasamak(disla, gerek) {
    var adaylar = gecmisOku().filter(function (h) { return disla.indexOf(h) < 0; }).slice(0, gerek + 2);
    if (!adaylar.length) return Promise.resolve([]);
    return Promise.all(adaylar.map(function (h) { return json('/products/' + h + '.js'); }))
      .then(function (l) { return l.map(normalle).filter(Boolean); });
  }

  /* Tek urun icin oneri cek. `niyet`: 'complementary' | 'related' */
  function oneriCek(urunId, gerek, niyet) {
    if (!urunId) return Promise.resolve([]);
    var n = Math.min(10, Math.max(1, gerek));   // Shopify ucu limit 1-10 kabul eder
    return json('/recommendations/products.json?product_id=' + urunId + '&limit=' + n + '&intent=' + niyet)
      .then(function (d) {
        if (!d || !Array.isArray(d.products)) return [];
        return d.products.map(normalle).filter(Boolean);
      });
  }

  /* Sepetteki TUM urunler icin ayni niyetle oneri cekip birlestirir.
     Sonuclar sepet sirasina gore geliyor; ilk urunun onerileri once. */
  function oneriHepsi(idler, gerek, niyet) {
    if (!idler.length) return Promise.resolve([]);
    return Promise.all(idler.map(function (id) { return oneriCek(id, gerek, niyet); }))
      .then(function (l) {
        var d = [];
        l.forEach(function (grup) { grup.forEach(function (u) { d.push(u); }); });
        return d;
      });
  }

  /* Son care: sepetteki urunlerin koleksiyonlarindan doldur. Serit 13
     urunluk oldugu icin TEK koleksiyon yetmeyebilir - hepsi taraniyor. */
  function koleksiyonBasamak(koleksiyonlar, gerek) {
    if (!koleksiyonlar.length) return Promise.resolve([]);
    return Promise.all(koleksiyonlar.slice(0, 3).map(function (k) {
      return json('/collections/' + k + '/products.json?limit=' + Math.min(250, gerek + 12));
    })).then(function (l) {
      var d = [];
      l.forEach(function (r) {
        if (r && Array.isArray(r.products)) r.products.map(normalle).filter(Boolean).forEach(function (u) { d.push(u); });
      });
      return d;
    });
  }

  /* ------------------------------------------------------------ cizim */

  function kartYaz(u, varyant, etiketler) {
    var li = document.createElement('li');
    li.className = 'sepone__oge';

    var yol = '/products/' + u.handle;
    /* Serit kartlari genis; kucuk resim bulanik kalmasin diye daha buyuk
       boy isteniyor (kaynak gorseller 800px, ustune cikilmiyor). */
    var boy = varyant === 'serit' ? '_600x' : '_120x';
    var kucuk = u.gorsel ? u.gorsel.replace(/(\.[a-z]+)(\?|$)/i, boy + '$1$2') : '';
    var olcu = varyant === 'serit' ? '' : ' width="52" height="52"';

    if (varyant === 'serit') {
      li.innerHTML =
        '<a class="sepone__gorsel-bag" href="' + yol + '" tabindex="-1" aria-hidden="true">' +
        (kucuk ? '<img class="sepone__gorsel" src="' + kucuk + '" alt="" loading="lazy">' : '<span class="sepone__gorsel"></span>') +
        '</a>' +
        '<a class="sepone__ad" href="' + yol + '"></a>' +
        '<span class="sepone__fiyat"></span>' +
        '<button class="sepone__ekle" type="button"></button>';
    } else {
      li.innerHTML =
        '<a href="' + yol + '" tabindex="-1" aria-hidden="true">' +
        (kucuk ? '<img class="sepone__gorsel" src="' + kucuk + '" alt="" loading="lazy"' + olcu + '>' : '<span class="sepone__gorsel"></span>') +
        '</a>' +
        '<div><a class="sepone__ad" href="' + yol + '"></a><span class="sepone__fiyat"></span></div>' +
        '<button class="sepone__ekle" type="button"></button>';
    }

    // Baslik textContent ile - urun adinda HTML enjeksiyonu olmasin.
    li.querySelector('.sepone__ad').textContent = u.baslik;
    li.querySelector('.sepone__fiyat').textContent = para.format(u.fiyat) + ' TL';

    var btn = li.querySelector('.sepone__ekle');
    btn.textContent = etiketler.ekle;
    btn.addEventListener('click', function () {
      if (!window.GPCart || !window.GPCart.add) return;
      btn.disabled = true;
      btn.textContent = '...';
      window.GPCart.add(u.varyant, 1)
        .then(function () {
          btn.textContent = etiketler.eklendi;
          return window.GPCart.refresh();
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = etiketler.ekle;
        });
    });

    return li;
  }

  /* ------------------------------------------------------------ serit */

  /* Yatay kaydirmali serit: oklar bir SAYFA kaydirir, noktalar sayfa
     sayisini gosterir. Sayfa = seridin gorunen genisligi. Kart sayisi
     ekran genisligine gore CSS'te degistigi icin JS sabit sayi
     VARSAYMIYOR, olculen genislikten hesapliyor. */
  function seritKur(kok) {
    var liste = kok.querySelector('[data-sepone-liste]');
    var noktaKap = kok.querySelector('[data-sepone-noktalar]');
    var onceki = kok.querySelector('[data-sepone-onceki]');
    var sonraki = kok.querySelector('[data-sepone-sonraki]');
    if (!liste) return;

    function sayfaSayisi() {
      if (!liste.clientWidth) return 1;
      return Math.max(1, Math.ceil(liste.scrollWidth / liste.clientWidth));
    }

    function aktifSayfa() {
      if (!liste.clientWidth) return 0;
      return Math.round(liste.scrollLeft / liste.clientWidth);
    }

    function noktalariCiz() {
      if (!noktaKap) return;
      var n = sayfaSayisi();
      noktaKap.innerHTML = '';
      if (n < 2) return;                       // tek sayfaysa nokta gosterme
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sepone__nokta';
        b.setAttribute('aria-label', String(i + 1));
        (function (idx) {
          b.addEventListener('click', function () {
            liste.scrollTo({ left: idx * liste.clientWidth, behavior: 'smooth' });
          });
        })(i);
        noktaKap.appendChild(b);
      }
      guncelle();
    }

    function guncelle() {
      var a = aktifSayfa();
      var n = sayfaSayisi();
      if (noktaKap) {
        [].forEach.call(noktaKap.children, function (b, i) { b.classList.toggle('is-on', i === a); });
      }
      if (onceki) onceki.disabled = liste.scrollLeft <= 2;
      if (sonraki) sonraki.disabled = liste.scrollLeft >= liste.scrollWidth - liste.clientWidth - 2;
      return n;
    }

    if (onceki) onceki.addEventListener('click', function () {
      liste.scrollTo({ left: liste.scrollLeft - liste.clientWidth, behavior: 'smooth' });
    });
    if (sonraki) sonraki.addEventListener('click', function () {
      liste.scrollTo({ left: liste.scrollLeft + liste.clientWidth, behavior: 'smooth' });
    });

    var bekle;
    liste.addEventListener('scroll', function () {
      clearTimeout(bekle);
      bekle = setTimeout(guncelle, 80);
    }, { passive: true });

    window.addEventListener('resize', noktalariCiz);
    noktalariCiz();
  }

  /* ---------------------------------------------------------- kurulum */

  function kur(kok) {
    if (kok.dataset.hazir === '1') return;
    kok.dataset.hazir = '1';

    var varyant = kok.dataset.varyant || 'kompakt';
    var sepette = (kok.dataset.sepettekiler || '').split(',').filter(Boolean);
    var koleksiyonlar = (kok.dataset.koleksiyonlar || '').split(',').filter(Boolean);
    var urunIdler = (kok.dataset.urunIdler || '').split(',').filter(Boolean);
    if (!urunIdler.length && kok.dataset.urunId) urunIdler = [kok.dataset.urunId];
    var adet = parseInt(kok.dataset.adet, 10) || 4;
    var etiketler = {
      ekle: kok.dataset.ekle || 'Ekle',
      eklendi: kok.dataset.eklendi || 'Eklendi'
    };

    var secilen = [];
    var gorulen = {};
    sepette.forEach(function (h) { gorulen[h] = true; });   // sepettekiler tekrar onerilmez

    function topla(liste) {
      liste.forEach(function (u) {
        if (secilen.length >= adet) return;
        if (gorulen[u.handle]) return;
        gorulen[u.handle] = true;
        secilen.push(u);
      });
    }

    function eksik() { return adet - secilen.length; }

    /* Basamaklar SIRAYLA denenir; kutu dolana kadar bir sonrakine gecilir.
       Yarim dolu serit gostermek yerine sirayi koruyup ustunu dolduruyoruz. */
    oneriHepsi(urunIdler, adet, 'complementary')
      .then(function (l) {
        topla(l);
        return eksik() > 0 ? oneriHepsi(urunIdler, adet, 'related') : [];
      })
      .then(function (l) {
        topla(l);
        return eksik() > 0 ? gecmisBasamak(sepette, eksik()) : [];
      })
      .then(function (l) {
        topla(l);
        return eksik() > 0 ? koleksiyonBasamak(koleksiyonlar, eksik()) : [];
      })
      .then(function (l) {
        topla(l);
        if (!secilen.length) return;   // gosterecek bir sey yoksa kutu hic acilmaz

        var liste = kok.querySelector('[data-sepone-liste]');
        liste.innerHTML = '';
        secilen.forEach(function (u) { liste.appendChild(kartYaz(u, varyant, etiketler)); });
        kok.hidden = false;

        /* Serit olculeri ancak kutu GORUNUR olunca dogru okunur
           (hidden iken clientWidth = 0 -> sayfa sayisi yanlis cikar). */
        if (varyant === 'serit') requestAnimationFrame(function () { seritKur(kok); });
      })
      .catch(function () { /* oneri gosterilememesi sepeti bozmaz - sessiz gec */ });
  }

  function hepsi() {
    document.querySelectorAll('[data-sepet-oneri]').forEach(kur);
  }

  /* Sepet degisince theme.js `[data-cart-content]` icerigini komple
     degistiriyor; kutu yeniden olusuyor ve `data-hazir` bayragi sifirlaniyor.
     Bu yuzden o kutuyu izleyip yeniden kuruyoruz. */
  function izleyiciKur() {
    var hedef = document.querySelector('[data-cart-content]');
    if (!hedef || hedef.dataset.seponeIzleniyor === '1') return;
    hedef.dataset.seponeIzleniyor = '1';
    new MutationObserver(function () { hepsi(); }).observe(hedef, { childList: true, subtree: true });
  }

  function basla() {
    izle();
    hepsi();
    izleyiciKur();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', basla);
  } else {
    basla();
  }
  document.addEventListener('shopify:section:load', basla);
})();
